import { __extends } from "tslib";
import { onCLS, onFCP, onINP, onLCP, onTTFB,
// @ts-ignore:next-line
 } from 'web-vitals';
import { InstrumentationBase } from '@opentelemetry/instrumentation';
import { trace, context } from '@opentelemetry/api';
import { hrTime } from '@opentelemetry/core';
import getRouteName from './get-route-name';
var WebVitalsInstrumentation = /** @class */ (function (_super) {
    __extends(WebVitalsInstrumentation, _super);
    function WebVitalsInstrumentation(routes, version) {
        var _this = _super.call(this, 'web-vitals', version, {}) || this;
        _this.enabled = false;
        _this._routes = routes;
        return _this;
    }
    // override unnecessary init
    WebVitalsInstrumentation.prototype.init = function () { };
    WebVitalsInstrumentation.prototype.onReport = function (metric, parentSpanContext) {
        var _a;
        var now = hrTime();
        var route = getRouteName(this._routes);
        var webVitalsSpan = trace
            .getTracer('web-vitals-instrumentation')
            .startSpan(metric.name, { startTime: now }, parentSpanContext);
        webVitalsSpan.setAttributes((_a = {},
            _a["site.page"] = route,
            _a["web_vital.name"] = metric.name,
            _a["web_vital.id"] = metric.id,
            _a["web_vital.navigationType"] = metric.navigationType,
            _a["web_vital.delta"] = metric.delta,
            _a["web_vital.rating"] = metric.rating,
            _a["web_vital.value"] = metric.value,
            _a["web_vital.entries"] = JSON.stringify(metric.entries),
            _a["web_vital.userAgent"] = navigator.userAgent,
            _a["web_vital.href"] = location.href,
            _a));
        webVitalsSpan.end();
    };
    WebVitalsInstrumentation.prototype.enable = function () {
        var _this = this;
        if (this.enabled) {
            return;
        }
        this.enabled = true;
        // create a parent span that will have all web vitals spans as children
        var parentSpan = trace
            .getTracer('web-vitals-instrumentation')
            .startSpan('web-vitals');
        var ctx = trace.setSpan(context.active(), parentSpan);
        parentSpan.end();
        onCLS(function (metric) {
            _this.onReport(metric, ctx);
        });
        onFCP(function (metric) {
            _this.onReport(metric, ctx);
        });
        onINP(function (metric) {
            _this.onReport(metric, ctx);
        });
        onLCP(function (metric) {
            _this.onReport(metric, ctx);
        });
        onTTFB(function (metric) {
            _this.onReport(metric, ctx);
        });
    };
    return WebVitalsInstrumentation;
}(InstrumentationBase));
export { WebVitalsInstrumentation };
//# sourceMappingURL=web-vitals-instrumentation.js.map